import getIsCurrentSubscription from '@utils/subscriptionHelpers/getIsCurrentSubscription';

const hasActiveSubscriptionToGoal = (meInfo, goalUID) => {
  /* this function is used for finding a active subscription to goal
    if we need to find whether its iconic or regular we can send the
    subscription_active param too
  */

  if (!meInfo?.uid || !goalUID) return false;
  const filteredData =
    (
      meInfo?.latestUserSubscriptions || meInfo?.latestUserSubscriptionsTypeWise
    )?.filter(
      (item) =>
        item.subscription?.value.uid === goalUID &&
        getIsCurrentSubscription(item)
    ) || [];

  return Boolean(filteredData?.length);
};

export default hasActiveSubscriptionToGoal;
